import { apiFetch } from "./api";

export interface FavoriteModule {
  module_id: string;
}

export function getFavoriteModules() {
  return apiFetch<FavoriteModule[]>("/api/favorites");
}

export function addFavoriteModule(moduleId: string) {
  return apiFetch<void>("/api/favorites", {
    method: "POST",
    body: JSON.stringify({ module_id: moduleId }),
  });
}

export function removeFavoriteModule(moduleId: string) {
  return apiFetch<void>(`/api/favorites/${moduleId}`, {
    method: "DELETE",
  });
}
